import { render } from "./DashboardStatus.vue?vue&type=template&id=db65113a&scoped=true"
import script from "./DashboardStatus.vue?vue&type=script&lang=js"
export * from "./DashboardStatus.vue?vue&type=script&lang=js"

import "./DashboardStatus.vue?vue&type=style&index=0&id=db65113a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db65113a"]])

export default __exports__